import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';
import { initializeSocket } from '../services/socket';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    fetchNotifications();
    const socket = initializeSocket();
    socket.emit('join-room', `user-${user._id}`);
    socket.on('new-notification', (notif) => {
      setNotifications(prev => [notif, ...prev]);
      setUnreadCount(prev => prev + 1);
    });
    return () => { socket.off('new-notification'); };
  }, [user]);

  const fetchNotifications = async () => {
    try {
      const res = await api.get('/notifications?limit=10');
      setNotifications(res.data.data.notifications);
      setUnreadCount(res.data.data.unreadCount);
    } catch (e) {}
  };

  const markAsRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    setUnreadCount(prev => Math.max(0, prev - 1));
  };

  const markAllAsRead = async () => {
    await api.patch('/notifications/read-all');
    setUnreadCount(0);
  };

  return <NotificationContext.Provider value={{ notifications, unreadCount, markAsRead, markAllAsRead }}>{children}</NotificationContext.Provider>;
};

export const useNotifications = () => useContext(NotificationContext);